<div class="bc-row">
    <div class="bc-col-12">
        <bc-table-container *ngIf="dataFactura.adjuntos" class="bc-col-12 "
            [dataTable]="ordenarPorFechaAdjuntos(dataFactura.adjuntos)">
            <bc-table-header title="Archivos adjuntos ({{ dataFactura.adjuntos.length }})">
            </bc-table-header>
            <bc-table-content>
                <div><p>Los archivos adjuntos se encuentran en orden descendente con base en la columna 'Fecha'</p></div>
                <div class="bc-mt-5">
                <table caption="tabla" bc-table [sort]="true" [pairPaginators]="true" [dropdownHtml]="true">
                    <thead>
                        <tr>
                            <th scope="row" bc-cell scope="col">Archivo</th>
                            <th scope="row" bc-cell scope="col">Usuario</th>
                            <th scope="row" bc-cell scope="col">Fecha</th>
                            <th scope="row" bc-cell scope="col">Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of dataFactura.adjuntos">
                            <td bc-cell>{{ row.id }}</td>
                            <td bc-cell>{{ row.usuario }}</td>
                            <td bc-cell>{{ row.fecha | date: 'dd/MM/yyyy HH:mm'}}</td>
                            <td bc-cell>
                                <bc-icon-button [type]="'solid'" [color]="'yellow'" [shadow]="true"
                                    [size]="'small'" [customIcon]="'cloud-download'"
                                    (click)="generarURL(row.id)"></bc-icon-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </bc-table-content>
        </bc-table-container>
    </div>
</div>